export const HELP_DEFINITIONS = {
    'level-overview': {
        steps: [
            {
                target: '[data-help="sidebar-levels"]',
                title: { fr: 'Le menu de gauche', en: 'The left menu' },
                description: {
                    fr: 'Chaque pastille représente un niveau de formation (PL, PPL, CPL…). Clique sur un niveau pour afficher son tableau de bord. Les niveaux actifs (abonnement en cours) et le PSTAR (gratuit) sont affichés par défaut.',
                    en: 'Each pill represents a training level (PL, PPL, CPL…). Click a level to display its dashboard. Active levels (current subscription) and PSTAR (free) are displayed by default.'
                },
                position: 'right',
            },
            {
                target: '[data-help="add-level-button"]',
                title: { fr: 'Le bouton « + »', en: 'The "+" button' },
                description: {
                    fr: 'Clique sur « + » pour ouvrir le gestionnaire de niveaux. Tu pourras cocher/décocher les niveaux à afficher et réorganiser leur ordre par glisser-déposer.',
                    en: 'Click "+" to open the level manager. You can check/uncheck levels to display and reorder them by drag and drop.'
                },
                position: 'right',
            },
            {
                target: '[data-help="banner-stats"]',
                title: { fr: 'Tes statistiques en un clin d\'œil', en: 'Your stats at a glance' },
                description: {
                    fr: 'Glisse horizontalement sur mobile pour voir tes 4 indicateurs clés : jours restants, progression, compréhension et récompenses. Clique sur chaque carte pour voir le détail.',
                    en: 'Swipe horizontally on mobile to see your 4 key indicators: days remaining, progression, comprehension and rewards. Click each card for details.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="tab-navigation"]',
                title: { fr: 'Explore par onglet', en: 'Explore by tab' },
                description: {
                    fr: 'Bascule entre Examens, Statistiques, Sur mesure et Cours pour explorer toutes les facettes de ton niveau.',
                    en: 'Switch between Exams, Statistics, Custom and Courses to explore all aspects of your level.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="keyword-exam"]',
                title: { fr: 'Examen Mots-clés', en: 'Keywords Exam' },
                description: {
                    fr: 'Cet examen spécial teste ta connaissance des termes techniques. Un excellent point de départ pour chaque session d\'étude !',
                    en: 'This special exam tests your knowledge of technical terms. A great starting point for each study session!'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="category-selector"]',
                title: { fr: 'Choisis une catégorie', en: 'Choose a category' },
                description: {
                    fr: 'Filtre tes examens par matière : Droit Aérien, Connaissances Générales, Météorologie, Navigation ou Examen Complet.',
                    en: 'Filter your exams by subject: Air Law, General Knowledge, Meteorology, Navigation or Full Exam.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="exam-cards"]',
                title: { fr: 'Tes examens', en: 'Your exams' },
                description: {
                    fr: 'Chaque carte représente un examen. Les barres de progression montrent ton avancement et ton score. Clique sur « Commencer » pour démarrer ou « Continuer » pour reprendre.',
                    en: 'Each card represents an exam. Progress bars show your advancement and score. Click "Start" to begin or "Continue" to resume.'
                },
                position: 'top',
            },
        ],
    },
    'dashboard-layout': {
        steps: [
            {
                target: '[data-help="sidebar-levels"]',
                title: { fr: 'Le menu de gauche', en: 'The left menu' },
                description: {
                    fr: 'Chaque pastille représente un niveau de formation (PL, PPL, CPL…). Clique sur un niveau pour afficher son tableau de bord. Les niveaux actifs (abonnement en cours) et le PSTAR (gratuit) sont affichés par défaut.',
                    en: 'Each pill represents a training level (PL, PPL, CPL…). Click a level to display its dashboard. Active levels (current subscription) and PSTAR (free) are displayed by default.'
                },
                position: 'right',
            },
            {
                target: '[data-help="add-level-button"]',
                title: { fr: 'Le bouton « + »', en: 'The "+" button' },
                description: {
                    fr: 'Clique sur « + » pour ouvrir le gestionnaire de niveaux. Tu pourras : 1) Cocher/décocher les niveaux à afficher dans le menu, puis 2) Réorganiser leur ordre par glisser-déposer. Même les niveaux non achetés peuvent être ajoutés pour explorer leur contenu.',
                    en: 'Click "+" to open the level manager. You can: 1) Check/uncheck levels to display in the menu, then 2) Reorder them by drag and drop. Even unpurchased levels can be added to explore their content.'
                },
                position: 'right',
            },
        ],
    },
    'level-selector': {
        steps: [
            {
                target: '[data-help="level-step-indicator"]',
                title: { fr: 'Deux étapes simples', en: 'Two simple steps' },
                description: {
                    fr: 'Ce gestionnaire fonctionne en 2 étapes : d\'abord tu choisis quels niveaux afficher, puis tu organises leur ordre dans le menu.',
                    en: 'This manager works in 2 steps: first you choose which levels to display, then you organize their order in the menu.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="level-type-filter"]',
                title: { fr: 'Filtrer par type d\'appareil', en: 'Filter by aircraft type' },
                description: {
                    fr: 'Utilise ces onglets pour filtrer les niveaux par type : Avion, Hélicoptère, Planeur ou Dispatch. Chaque type affiche uniquement les niveaux correspondants.',
                    en: 'Use these tabs to filter levels by type: Airplane, Helicopter, Glider or Dispatch. Each type shows only its matching levels.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="level-list"]',
                title: { fr: 'Étape 1 : Choisir les niveaux', en: 'Step 1: Choose levels' },
                description: {
                    fr: 'Coche les niveaux que tu veux voir dans ton menu de gauche. Les badges « Actif », « Gratuit », « Expiré » ou « Disponible » t\'indiquent le statut de chaque niveau. Tu peux ajouter des niveaux même sans abonnement pour explorer leur contenu.',
                    en: 'Check the levels you want in your left menu. The badges "Active", "Free", "Expired" or "Available" show each level\'s status. You can add levels even without a subscription to explore their content.'
                },
                position: 'top',
            },
            {
                target: '[data-help="level-footer"]',
                title: { fr: 'Étape 2 : Organiser l\'ordre', en: 'Step 2: Organize order' },
                description: {
                    fr: 'Clique sur « Suivant » pour passer à l\'étape 2 où tu pourras réorganiser l\'ordre des niveaux par glisser-déposer. Puis clique « Enregistrer » pour sauvegarder tes changements.',
                    en: 'Click "Next" to go to step 2 where you can reorder levels by drag and drop. Then click "Save" to save your changes.'
                },
                position: 'top',
            },
        ],
    },
    'account': {
        steps: [
            {
                target: '[data-help="account-nav"]',
                title: { fr: 'Le menu de ton compte', en: 'Your account menu' },
                description: {
                    fr: 'Tout ton espace est regroupé ici. « Mon espace » : Mes achats (commandes, factures), Victoires (badges et progression), Mes infos (nom, courriel, mot de passe, avatar), Mes parrainages, Notifications (alertes et messages de l\'équipe), Recommandation (lettre officielle Transport Canada) et Relevé d\'heures. « Aide & ressources » : Tutoriel (visites guidées), Blog, FAQ et À propos. Une section « Administration » apparaît si tu es admin ou représentant d\'école.',
                    en: 'Your whole account lives here. "My space": Purchases (orders, invoices), Victories (badges and progress), My info (name, email, password, avatar), Referrals, Notifications (alerts and team messages), Recommendation (official Transport Canada letter), and Hours record. "Help & resources": Tutorial (guided tours), Blog, FAQ, and About. An "Administration" section appears for admins or school representatives.'
                },
                position: 'right',
            },
            {
                target: '[data-help="account-content"]',
                title: { fr: 'Le contenu de la section', en: 'Section content' },
                description: {
                    fr: 'La section sélectionnée s\'affiche ici. Tu peux naviguer d\'une section à l\'autre sans fermer cette fenêtre. Sur mobile, tape sur une entrée du menu pour ouvrir la section, puis utilise la flèche en haut pour revenir au menu.',
                    en: 'The selected section is displayed here. You can switch between sections without closing this window. On mobile, tap a menu item to open the section, then use the back arrow at the top to return to the menu.'
                },
                position: 'left',
            },
            {
                target: '[data-help="account-display-settings"]',
                title: { fr: 'Langue & affichage', en: 'Language & display' },
                description: {
                    fr: 'En bas du menu : bascule la langue (français/anglais) et le thème (clair/sombre) à tout moment. La flèche en haut à gauche ferme cette fenêtre et te ramène au tableau de bord.',
                    en: 'At the bottom of the menu: switch language (French/English) and theme (light/dark) at any time. The arrow at the top left closes this window and takes you back to the dashboard.'
                },
                position: 'top',
            },
        ],
    },
    'order-history': {
        steps: [
            {
                target: '[data-help="order-list"]',
                title: { fr: 'Historique de tes commandes', en: 'Your order history' },
                description: {
                    fr: 'Retrouve ici toutes tes commandes passées avec leur statut, la date et le montant. Clique sur « Facture » pour télécharger le justificatif.',
                    en: 'Find all your past orders here with their status, date and amount. Click "Invoice" to download the receipt.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="buy-extend-cta"]',
                title: { fr: 'Besoin de plus de temps ?', en: 'Need more time?' },
                description: {
                    fr: 'Clique ici pour prolonger ton abonnement ou en acheter un nouveau.',
                    en: 'Click here to extend your subscription or buy a new one.'
                },
                position: 'bottom',
            },
        ],
    },
    'exam-session': {
        steps: [
            {
                target: '[data-help="session-header"]',
                title: { fr: 'Contrôles de l\'examen', en: 'Exam controls' },
                description: {
                    fr: 'En haut : flèche retour au tableau de bord, libellé de l\'examen en cours, bouton Valider (vert) pour soumettre, et engrenage pour les options (redémarrer, quitter, langue/thème sur mobile).',
                    en: 'Top bar: back arrow to dashboard, current exam title, Validate button (green) to submit, and gear for options (restart, quit, language/theme on mobile).'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="session-mini-nav"]',
                title: { fr: 'Navigateur de questions', en: 'Question navigator' },
                description: {
                    fr: 'Chaque pastille = une question. Les couleurs indiquent ta progression : gris (non vue), bleu (répondue), vert (correcte en mode flash), rouge (incorrecte). Clique pour sauter à une question. Sur ordinateur, la navigation est intégrée à l\'en-tête ; sur mobile, elle apparaît juste en dessous.',
                    en: 'Each dot = one question. Colors show your progress: gray (unseen), blue (answered), green (correct in flash mode), red (incorrect). Click to jump to a question. On desktop the navigator is embedded in the header; on mobile it sits just below.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="session-question"]',
                title: { fr: 'Zone de réponse', en: 'Answer area' },
                description: {
                    fr: 'Lis la question et clique sur la bonne réponse. En mode Question-réponse, l\'explication s\'affiche immédiatement. En mode Examen, tu verras les résultats à la fin. Utilise les flèches latérales pour naviguer.',
                    en: 'Read the question and click the correct answer. In Flashcard mode, the explanation appears immediately. In Exam mode, you\'ll see results at the end. Use side arrows to navigate.'
                },
                position: 'top',
            },
            {
                target: '[data-help="session-footer"]',
                title: { fr: 'Progression et pause', en: 'Progress and pause' },
                description: {
                    fr: 'La barre montre ton avancement. Le bouton pause met le chronomètre en attente. Le temps total est enregistré pour tes statistiques.',
                    en: 'The bar shows your progress. The pause button pauses the timer. Total time is recorded for your statistics.'
                },
                position: 'top',
            },
        ],
    },
    'quiz-session': {
        steps: [
            {
                target: '[data-help="session-header"]',
                title: { fr: 'Contrôles du quiz', en: 'Quiz controls' },
                description: {
                    fr: 'En haut : flèche retour, titre du cours associé au quiz, bouton Valider pour soumettre tes réponses, et engrenage pour les options (redémarrer, quitter, langue/thème sur mobile).',
                    en: 'Top bar: back arrow, title of the course linked to this quiz, Validate button to submit, and gear for options (restart, quit, language/theme on mobile).'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="session-mini-nav"]',
                title: { fr: 'Navigation des questions', en: 'Question navigator' },
                description: {
                    fr: 'Chaque pastille représente une question : gris (non vue), bleu (répondue), vert/rouge en mode révision. Clique pour sauter directement à une question. Intégrée à l\'en-tête sur ordinateur, juste en dessous sur mobile.',
                    en: 'Each dot represents a question: gray (unseen), blue (answered), green/red in review mode. Click to jump straight to a question. Embedded in the header on desktop, just below it on mobile.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="session-question"]',
                title: { fr: 'Réponds aux questions du cours', en: 'Answer course questions' },
                description: {
                    fr: 'Ces questions testent ta compréhension du cours que tu viens de lire. Un bon score confirme que tu maîtrises le sujet !',
                    en: 'These questions test your understanding of the course you just read. A good score confirms you\'ve mastered the topic!'
                },
                position: 'top',
            },
            {
                target: '[data-help="session-footer"]',
                title: { fr: 'Ta progression', en: 'Your progress' },
                description: {
                    fr: 'Suis ton avancement dans le quiz. Le pourcentage indique combien de questions tu as répondu.',
                    en: 'Track your progress in the quiz. The percentage shows how many questions you\'ve answered.'
                },
                position: 'top',
            },
        ],
    },
    'course-modal': {
        steps: [
            {
                target: '[data-help="course-chapters"]',
                title: { fr: 'Plan du cours', en: 'Course outline' },
                description: {
                    fr: 'Sur ordinateur, le panneau de gauche affiche le titre du cours, un bouton burger sur le bord droit qui rétracte/déploie le panneau pour gagner de la place, la liste verticale des sections, ainsi que la progression, le chrono et le bouton pause en bas. La flèche retour, en haut à gauche (hors du panneau), ferme la session. Sur mobile, les sections sont accessibles via les pastilles défilables en haut. Cercle vide = à lire, coche bleue = validée cette session, coche verte = déjà validée auparavant.',
                    en: 'On desktop, the left panel shows the course title, a burger button on the right edge that collapses/expands the panel to free up space, the vertical list of sections, plus progress, timer and pause button at the bottom. The back arrow at the top left (outside the panel) closes the session. On mobile, sections are reachable through the scrollable pills at the top. Empty circle = unread, blue check = validated this session, green check = previously validated.'
                },
                position: 'right',
            },
            {
                target: '[data-help="course-controls"]',
                title: { fr: 'Contrôles flottants', en: 'Floating controls' },
                description: {
                    fr: 'En haut à droite, les pastilles flottantes regroupent : bascule de thème (clair/sombre), changement de langue (FR/EN), options audio (engrenage, si l\'audio est disponible) et le bouton vert « Terminer » qui clôture la session quand toutes les sections sont validées.',
                    en: 'Top-right floating pills group: theme toggle (light/dark), language switch (FR/EN), audio options (gear, when audio is available) and the green "Complete" button that closes the session once every section is validated.'
                },
                position: 'left',
            },
            {
                target: '[data-help="course-content"]',
                title: { fr: 'Contenu de la section', en: 'Section content' },
                description: {
                    fr: 'Le texte, les images et les médias de la section active s\'affichent ici. Quand de l\'audio est disponible, un petit bouton lecture apparaît à côté de chaque paragraphe pour écouter ce paragraphe précis.',
                    en: 'Text, images and media for the active section appear here. When audio is available, a small play button appears next to each paragraph so you can listen to that exact paragraph.'
                },
                position: 'top',
            },
            {
                target: '[data-help="course-audio"]',
                title: { fr: 'Lecture audio', en: 'Audio playback' },
                description: {
                    fr: 'Quand l\'audio est disponible : barre flottante en bas (ordinateur) ou intégrée au contenu (mobile). Lecture/pause, paragraphe précédent/suivant, et reculer/avancer de 10 secondes. Volume, vitesse et lecture automatique se règlent via l\'engrenage en haut à droite.',
                    en: 'When audio is available: floating bar at the bottom (desktop) or inline within the content (mobile). Play/pause, previous/next paragraph, and rewind/forward 10 seconds. Volume, speed and auto-play are configured via the gear icon in the top right.'
                },
                position: 'top',
            },
            {
                target: '[data-help="course-validate"]',
                title: { fr: 'Valider la section', en: 'Validate section' },
                description: {
                    fr: 'Après avoir lu la section, clique sur « Valider et continuer » pour passer à la suivante. Quand toutes les sections sont validées, la session se termine automatiquement !',
                    en: 'After reading the section, click "Validate and continue" to move on. When all sections are validated, the session ends automatically!'
                },
                position: 'top',
            },
        ],
    },
    'stats-tab': {
        steps: [
            {
                target: '[data-help="stats-summary"]',
                title: { fr: 'Résumé de tes scores', en: 'Your scores summary' },
                description: {
                    fr: 'Le cercle montre ton score moyen et le nombre d\'examens terminés. En dessous, retrouve le détail par matière avec tes points forts et faibles.',
                    en: 'The circle shows your average score and number of completed exams. Below, find the breakdown by subject with your strengths and weaknesses.'
                },
                position: 'right',
            },
            {
                target: '[data-help="stats-chart"]',
                title: { fr: 'Graphique d\'évolution', en: 'Progress chart' },
                description: {
                    fr: 'Ce graphique retrace l\'évolution de tes scores au fil du temps. La ligne rouge indique le seuil de réussite. Clique sur un point pour revoir la session.',
                    en: 'This chart tracks your score evolution over time. The red line shows the passing threshold. Click a dot to review the session.'
                },
                position: 'left',
            },
            {
                target: '[data-help="stats-history"]',
                title: { fr: 'Historique détaillé', en: 'Detailed history' },
                description: {
                    fr: 'La liste complète de tes sessions d\'examen avec date, score et durée. Clique sur « Revoir » pour réviser tes réponses question par question.',
                    en: 'The complete list of your exam sessions with date, score and duration. Click "Review" to review your answers question by question.'
                },
                position: 'top',
            },
        ],
    },
    'custom-tab': {
        steps: [
            {
                target: '[data-help="custom-errors"]',
                title: { fr: 'Travailler tes erreurs', en: 'Work on your mistakes' },
                description: {
                    fr: 'Choisis un type d\'erreur (jamais réussies, ponctuelles ou récentes), définis le périmètre (niveau, catégorie ou examen) puis clique sur « Générer » pour créer un examen ciblé sur tes faiblesses.',
                    en: 'Choose an error type (never correct, occasional or recent), set the scope (level, category or exam) then click "Generate" to create a targeted exam on your weaknesses.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="custom-keywords"]',
                title: { fr: 'Recherche par mots-clés', en: 'Keyword search' },
                description: {
                    fr: 'Tape un ou plusieurs mots-clés pour trouver les questions correspondantes. Choisis entre « Questions sur mesure » (examen personnalisé) et « Examens ciblés » (examens complets contenant ce terme).',
                    en: 'Type one or more keywords to find matching questions. Choose between "Custom questions" (personalized exam) and "Targeted exams" (full exams containing that term).'
                },
                position: 'top',
            },
            {
                target: '[data-help="custom-history"]',
                title: { fr: 'Historique sur mesure', en: 'Custom history' },
                description: {
                    fr: 'Retrouve ici tous tes examens personnalisés passés avec leur score et durée. Clique pour revoir tes réponses en détail.',
                    en: 'Find all your past custom exams here with their score and duration. Click to review your answers in detail.'
                },
                position: 'top',
            },
        ],
    },
    'courses-tab': {
        steps: [
            {
                target: '[data-help="courses-modules"]',
                title: { fr: 'Choisis un module', en: 'Choose a module' },
                description: {
                    fr: 'Chaque carte représente un module de cours (Introduction, Droit Aérien, Météo…). La barre de progression montre ton avancement global et le temps total passé. Clique pour afficher les cours du module.',
                    en: 'Each card represents a course module (Introduction, Air Law, Meteo…). The progress bar shows your overall progress and total time spent. Click to display the module\'s courses.'
                },
                position: 'bottom',
            },
            {
                target: '[data-help="courses-list"]',
                title: { fr: 'Tes chapitres et sections', en: 'Your chapters and sections' },
                description: {
                    fr: 'Les chapitres sont regroupés par thème. Clique sur un groupe pour le déplier et voir ses chapitres. Chaque chapitre affiche sa progression, le pourcentage validé en session et le temps total. Le bouton « Stats » affiche ou masque ces détails.',
                    en: 'Chapters are grouped by topic. Click a group to expand and see its chapters. Each chapter shows its progress, session validation percentage and total time. The "Stats" button toggles these details.'
                },
                position: 'top',
            },
            {
                target: '[data-help="courses-card-first"]',
                title: { fr: 'Ouvrir un chapitre', en: 'Open a chapter' },
                description: {
                    fr: 'Clique sur « Commencer » ou « Continuer » pour ouvrir le chapitre. Tu y trouveras les sections à lire, des images, de l\'audio et un bouton pour valider chaque section. Un quiz peut aussi être associé au chapitre.',
                    en: 'Click "Start" or "Continue" to open the chapter. Inside you\'ll find sections to read, images, audio and a button to validate each section. A quiz may also be linked to the chapter.'
                },
                position: 'top',
            },
        ],
    },
};
